// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { wishListCardStyles } from "@tps/Overrides/Components/WishListCard";
import Close from "@tps/XDL/Icons/Close";
import { createLinkIconStyles, ellipsis, mergeWithCss, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

wishListCardStyles.gridContainer = {
    gap: 15,
};

wishListCardStyles.wishListInfoGridItem = {
    width: 10,
    align: "middle",
};

wishListCardStyles.basicInfoGridItem = {
    width: [12, 12, 5, 6, 6],
    css: css`
        align-items: center;
    `,
};

wishListCardStyles.detailLinkGridItem = {
    width: 12,
    css: css`
        & > ${StyledButton} {
            font-weight: bold;
        }
    `,
};

wishListCardStyles.extendedInfoGridItem = {
    width: [12, 12, 7, 6, 6],
    align: "middle",
    css: css`
        align-items: center;
    `,
};

wishListCardStyles.sharingStatusGridItem = {
    width: [12, 12, 7, 6, 6],
    css: css`
        justify-content: start;
        align-items: center;
        font-size: 12px;
        line-height: 13px;
        padding-top: 12px;
        ${xScreen("lte", "md")} {
            justify-content: flex-start;

            &:empty {
                display: none;
            }
        }
    `,
};

wishListCardStyles.actionGridMediumHidden = {
    css: css`
        width: auto;
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

wishListCardStyles.productImage = {
    width: "92px",
    height: "92px",
    css: css`
        ${xScreen("lte", "xs")} {
            width: 72px;
            height: 72px;
        }
        img {
            height: auto;
            max-height: 100%;
            max-width: 100%;
        }
    `,
    errorTypographyProps: {
        size: 11,
        css: css`
            max-height: 65px;
        `,
    },
};

wishListCardStyles.productImagesGridItem = {
    width: 12,
    css: css`
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        gap: 21px;

        ${xScreen("lte", "md")} {
            justify-content: flex-start;

            &:empty {
                display: none;
            }
        }

        ${xScreen("lte", "sm")} {
            padding: 13px 15px 10px;
        }
    `,
};

wishListCardStyles.lastUpdatedText = {
    size: 12,
    lineHeight: "13px",
};

wishListCardStyles.actionGridItem = {
    width: 2,
    css: css`
        justify-content: flex-end;
        align-items: center;
        ${xScreen("lte", "sm")} {
            align-items: flex-start;
        }
    `,
};

wishListCardStyles.sharingStatus = {
    statusText: {
        css: css`
            display: flex;
            align-items: center;
            span {
                margin-left: 0;
            }
        `,
    },
};

wishListCardStyles.actionAddToCartLink = {
    ...createLinkIconStyles("ShoppingCart"),
};

wishListCardStyles.actionDeleteLink = {
    ...createLinkIconStyles(Close),
};

wishListCardStyles.detailLink = {
    typographyProps: {
        size: 16,
    },
};

wishListCardStyles.descriptionText = {
    size: 14,
    css: css`
        ${ellipsis(2)}
    `,
};

wishListCardStyles.actionAddToCartButton = {
    ...mergeWithCss(wishListCardStyles.actionAddToCartButton, {
        color: "primary",
    }),
};
